export default __webpack_public_path__ + "static/media/cause4.d63c8e96.png";